<input
  #checkboxInput
  type="checkbox"
  [name]="item.label"
  [id]="item.label"
  class="form-check-input"
  [checked]="checked"
  (change)="toggleCheckbox($event)"
/>{{ prefix + "accept" | msg | async }}
<label [for]="item.label"
  ><a class="document-link">{{ prefix + item.label | msg | async }}</a></label
>
<app-validation
  [hidden]="!showValidation"
  [validationMessages]="[validationMessage]"
></app-validation>
